<template>
  <div :class="`task task-${task.importance}`">
    <div class="row align-items-start no-gutters">
      <div class="col">
        <div class="checkbox d-flex flex-row">
          <input type="checkbox"
                 @click="ticked"
                 :disabled="!rights.includes('change_task_status')"
                 :id="`tt-${task.id}`"
                 :checked="task.finished"/>
          <label :for="`tt-${task.id}`" class="task-checkbox-label"></label>
          <div class="task-teaser-content">
            <a class="pointer text-black"
               v-if="showInfoOnTitle"
               @click="showTaskModal">
              {{ task.title }}
            </a>
            <span v-else>{{ task.title }}</span>
            <a class="pointer ml-1"
               v-if="showInfo"
               @click="showTaskModal">
              <InfoSvg/>
            </a>
            <div class="small text-muted mt-1">
              {{ task.task_type == 'call' ? $t('call_noun') : $t(task.task_type) }}
              <span v-if="task.deadline" class="ml-1">{{ formatDateTime(task.deadline) }}</span>
            </div>
            <div class="small text-muted" v-if="task.description">{{ task.description }}</div>
            <div class="small text-muted" v-if="task.record">{{ $t('visit') }} {{ task.record.readableStart }}</div>
            <div v-if="task.patient" class="small">
              <router-link :to="{ name: 'PatientVisits', params: { id: task.patient_id }}">{{ task.patient.full_name }}</router-link>
              <span v-if="!rights.includes('hide_patient_phone')" class="d-inline-block px-2">|</span>
              <OutgoingCallElement :phone="task.patientPhone"/>
            </div>
            <div class="row align-items-center">
              <div class="col" v-if="task.user || (task.users && task.users.length)">
                <div v-if="task.users && task.users.length"
                     class="small d-inline-block">
                  <div v-for="(d, dind) in task.users"
                       :key="`dind-${dind}`">
                    {{ d.full_name }}
                  </div>
                </div>
                <div v-else class="small d-inline-block">
                  {{ task.user.full_name }}
                </div>
              </div>
              <!--              <div class="text-right col col-task.user ? 'auto' : '12'">-->
              <!--                <CRMDatatableTDTaskStatus :object="task"/>-->
              <!--              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="text-right col col-auto">
        <div>
          <a @click="deleteTask" class="deleteButton">
            <TrashSvg class="svg-light pointer"/>
          </a>
        </div>
        <CRMDatatableTDTaskStatus :object="task"
                                  class="mt-2"/>
      </div>
    </div>
  </div>
</template>

<script>

import TrashSvg from '@/assets/svg-vue/general/trash_tr.svg'
import InfoSvg from '@/assets/svg-vue/general/info2.svg'
import { EloquentService } from "@/services/api/eloquent.api.service"
import {CalendarService} from "@/services/api/calendar.api.service"
import CRMDatatableTDTaskStatus from "@/components/parts/datatable/td/crm/CRMDatatableTDTaskStatus"
import OutgoingCallElement from "@/components/parts/patients/OutgoingCallElement.vue"
import { formatDateTime } from "@/extensions/filters/filters"
import {mapState} from "vuex"

export default {
  name: "TaskTeaser",
  emits: ['loadTasks'],
  components: {
    OutgoingCallElement,
    CRMDatatableTDTaskStatus,
    TrashSvg,
    InfoSvg
  },
  props: {
    task: {
      type: Object,
      required: true
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    showInfoOnTitle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      rights: state => state.auth.rights,
    }),
  },
  methods: {
    formatDateTime,
    async ticked() {
      try {
        await CalendarService.finishTask(this.task.id)
        this.$emit('loadTasks')
      } catch (e) {
        console.log(e)
      }
    },
    deleteTask() {
      const res = confirm(this.$t('are_you_sure_you_want_to_delete_task'))
      if(res) {
        EloquentService.delete('task', this.task.id).then(() => {
          this.$emit('loadTasks')
        })
      }
    },
    showTaskModal() {
      this.$store.commit('setTask', this.copyObject(this.task))
      this.$bvModal.show('task-show-modal')
    }
  }
}
</script>

<style scoped lang="scss">
.task {
  padding: 14px 22px;
  border-bottom: 1px solid $calendar-border-color;

  &-low {
    border-left: 5px solid #fff;
  }
  &-high {
    background: #FFFAFA;
    border-left: 5px solid #DD1515;
  }
  &-medium {
    background: #FFFCF2;
    border-left: 5px solid #FEC943;

  }
  label {
    height: auto;
    color: #000;
  }
  .deleteButton {
    z-index: 2;
  }
  .task-checkbox-label {
    top: 11px;
  }
}

@media screen and (max-width: 768px) {

}
</style>
